'use client';

import React from 'react';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { EarnProductsByAsset } from 'src/hooks/useEarnProduct';
import { EarnProductByAssetMobile } from './EarnProductByAssetMobile';
import { EarnProductByAssetDesktop } from './EarnProductByAssetDesktop';

interface EarnProductByAssetComponentProps {
	info: EarnProductsByAsset;
	isLastProduct: boolean;
}

export const EarnProductByAssetComponent: React.FC<
	EarnProductByAssetComponentProps
> = ({ info, isLastProduct }) => {
	const isMobile = useIsMobileScreenSize();

	if (isMobile) {
		return <EarnProductByAssetMobile info={info} />;
	}

	return (
		<EarnProductByAssetDesktop info={info} isLastProduct={isLastProduct} />
	);
};
